export default "__VITE_ASSET__bb53e240__"